import axios, { AxiosResponse } from 'axios';
import * as utils from '@/apis/apiUtils';
import {
  SettouPatrolReportsParams,
  SpSettouPatrolReportExt,
} from '@/models/apis/johaisetsu/settouPatrol/settouPatrol/johaisetsuSettouPatrolReportsRequest';
import {
  SettouPatrolReport,
  SettouPatrolReports,
} from '@/models/apis/johaisetsu/settouPatrol/settouPatrol/johaisetsuSettouPatrolReportsResponse';

export default {
  index(params: SettouPatrolReportsParams): Promise<AxiosResponse<SettouPatrolReports>> {
    return axios.get(utils.getApiUrl('/johaisetsu_settou_patrol_reports'), {
      params: params || {},
    });
  },
  show(id: number): Promise<AxiosResponse<SettouPatrolReport>> {
    return axios.get(utils.getApiUrl(`/johaisetsu_settou_patrol_reports/${id}`));
  },
  create(params: SpSettouPatrolReportExt): Promise<AxiosResponse<SettouPatrolReport>> {
    const formData = utils.transformFormData(params);
    return axios.post(utils.getApiUrl('/johaisetsu_settou_patrol_reports'), formData);
  },
};
